import type { ChecklistState } from "./checklist.tsx";

const data: ChecklistState = {
    sections: [
        {
            title: "Photo Prompts",
            items: [
                { publishDate: "2026-06-12", name: "Love"},
                { publishDate: "2026-06-13", name: "Reflection"},
                { publishDate: "2026-06-14", name: "Wings"},
                { publishDate: "2026-06-15", name: "Colourful"},
                { publishDate: "2026-06-16", name: "Sun"},
                { publishDate: "2026-06-17", name: "Bloom"},
                { publishDate: "2026-06-18", name: "Looking up"},
                { publishDate: "2026-06-19", name: "Stripes"},
                { publishDate: "2026-06-20", name: "Path"},
                { publishDate: "2026-06-21", name: "Travel"},
                { publishDate: "2026-06-22", name: "Bridge"},
                { publishDate: "2026-06-23", name: "Shadow"},
                { publishDate: "2026-06-24", name: "Home"},
                { publishDate: "2026-06-25", name: "Clouds"},
                { publishDate: "2026-06-26", name: "Treat"},
                { publishDate: "2026-06-27", name: "Entrance"},
                { publishDate: "2026-06-28", name: "Wild"},
                { publishDate: "2026-06-29", name: "Celebrate"},
                { publishDate: "2026-06-30", name: "Wood"},
                { publishDate: "2026-07-01", name: "Furry Friend"},
                { publishDate: "2026-07-02", name: "Looking Down"},
                { publishDate: "2026-07-03", name: "Pattern"},
                { publishDate: "2026-07-04", name: "Evening Light"},
                { publishDate: "2026-07-05", name: "Glass"},
                { publishDate: "2026-07-06", name: "Stone"},
                { publishDate: "2026-07-07", name: "Arch"},
                { publishDate: "2026-07-08", name: "Play"},
                { publishDate: "2026-07-09", name: "Close Up"},
                { publishDate: "2026-07-10", name: "Sit"},
                { publishDate: "2026-07-11", name: "Water"}
            ]
        }, {
            title: "Scrapbook Challenges",
            items: [
                {publishDate: "2026-07-12",  name: "Recipe 1"},
                { publishDate: "2026-07-19", name: "Sketch 1"},
                { publishDate: "2026-07-26", name: "Tic-Tac-Toe"},
                { publishDate: "2026-08-02", name: "Pick 5"},
                { publishDate: "2026-08-09", name: "Scraplift"},
                { publishDate: "2026-08-16", name: "This or That"},
                { publishDate: "2026-08-23", name: "Sketch 2"},
                { publishDate: "2026-08-30", name: "Colour"},
                { publishDate: "2026-09-06", name: "Recipe 2"},
                { publishDate: "2026-09-13", name: "Tricky Tic‑Tac‑Toe"},
            ]
        }
    ],
    eventName: "Summer Photo Hunt 2026",
    eventShortName: "sph",
    closingDate: "Sunday 27th September 2026"
}

export default data;